import React, { useState } from 'react';
import { TextVariant } from '@naf/text';
import { HeroContentType } from '@appTypes/CategoryAppType';
import Timer from '@components/SectionBlocks/blocks/CountdownBlock/Timer';
import * as S from './HeroContent.styles';

const Countdown = ({ countdown }: Required<Pick<HeroContentType, 'countdown'>>) => {
  const [isFinished, setIsFinished] = useState(false);

  return isFinished ? (
    <S.TitleText variant={TextVariant.Display}>{countdown.endText}</S.TitleText>
  ) : (
    <Timer targetTime={countdown.countdownTo} onFinished={() => setIsFinished(true)} />
  );
};

export default Countdown;
